"use client";

import Script from "next/script";
import { config } from "@/app";
import { useTargetApiProvider } from "./target-api-provider.hook";

export function TargetApiScript() {
  const { sendTargetAPI } = useTargetApiProvider();

  return (
    <Script
      src={config.adobeSDK}
      strategy="afterInteractive"
      onLoad={() => {
        sendTargetAPI((window as unknown as { adobe: never }).adobe);
      }}
    />
  );
}
